import { memo, useContext } from 'react';

import PersonInPlaceEditor from '@/components/PersonInPlaceEditor';
import { FieldTypes } from '@/components/PersonInPlaceEditor/types';
import type { ArrayFieldValue } from '@/components/PersonInPlaceEditor/types';
import { emailTypes } from '@/constants/memberContactInfo';
import PersonContext from '@/pages/Person/PersonContext';
import { emailsSchema } from '@/pages/Profile/schemas';
import type { Person } from '@/types/person';
import DataList, { DataRow } from '@/ui/components/DataList';
import Heading from '@/ui/components/Heading';

const EmailSection = () => {
  const { person } = useContext(PersonContext);

  return (
    <div className="group/subsection mb-4 relative">
      <Heading className="mb-2" value={4} text="Email" />
      <PersonInPlaceEditor
        subsectionEditor
        schema={emailsSchema}
        fields={{
          key: 'emails',
          newObject: {
            id: undefined,
            default: false,
            address: '',
            type: 'work'
          } as ArrayFieldValue<Person, 'emails'>,
          fields: [
            {
              key: (idx: number) => `emails.${idx}.id`,
              label: '',
              type: FieldTypes.HIDDEN
            },
            {
              key: (idx: number) => `emails.${idx}.default`,
              label: 'Default',
              type: FieldTypes.BOOLEAN
            },
            {
              key: (idx: number) => `emails.${idx}.address`,
              label: 'Email',
              type: FieldTypes.TEXT
            },
            {
              key: (idx: number) => `emails.${idx}.type`,
              label: 'Type',
              type: FieldTypes.RADIO,
              options: emailTypes.map((type) => ({ label: type, value: type }))
            }
          ]
        }}>
        <DataList>
          {person.emails.map(({ address, default: isDefault, id, type }, idx) => (
            <DataRow
              key={`member-email-${id}`}
              label={`#${idx + 1} (${isDefault ? 'Default | ' : ''}${type})`}
              tooltipContent={
                isDefault
                  ? "The member's contact email is used for general communication."
                  : undefined
              }>
              <a
                className="inline-block overflow-hidden text-ellipsis text-blue-600 w-full"
                target="_blank"
                rel="noreferrer"
                href={`mailto:${address}`}>
                {address}
              </a>
            </DataRow>
          ))}
        </DataList>
      </PersonInPlaceEditor>
    </div>
  );
};

export default memo(EmailSection);
